import configdata from "../../config.json";
import { labourCostSliceAction } from "./LabourCost";
import { getApi } from "../BaseApi";
import { getOnlyValueFromSelectObject } from "../UseAbleFun";
import { appLevelSliceActions } from "../AppLevelApi/AppLevelSlice";

export const getAllLabourCostItems = () => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi(
      "get",
      `${configdata.SERVER_URL}/api/labour-costs`
    );

    dispatch(appLevelSliceActions.setLoadingState());
    dispatch(labourCostSliceAction.getAllLabourCost(res.data.labourCost));
  };
};
export const createLabourCostItem = (data) => {
  return async (dispatch) => {
    const { form } = getOnlyValueFromSelectObject(data);
    dispatch(appLevelSliceActions.setLoadingState());
    const resData = await getApi(
      "post",
      `${configdata.SERVER_URL}/api/labour-costs/store`,
      form
    );

    if (resData?.error) {
      if (resData?.errorType === "single") {
        dispatch(
          appLevelSliceActions.setError({ msg: resData.message, isError: true })
        );
      } else {
        dispatch(
          labourCostSliceAction.setErrorData({
            message: resData.message,
            isError: true,
          })
        );
      }

      dispatch(appLevelSliceActions.setLoadingState());
      return;
    }
    dispatch(
      labourCostSliceAction.setErrorData({
        message: {},
        isError: false,
      })
    );
    dispatch(appLevelSliceActions.setIsSuccess(true));
    dispatch(labourCostSliceAction.setInitialData());
    dispatch(appLevelSliceActions.setLoadingState());
    dispatch(getAllLabourCostItems());
  };
};
export const getDataForEdit = (id, factoryList) => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi(
      "get",
      `${configdata.SERVER_URL}/api/labour-costs/edit/${id}`
    );
    dispatch(appLevelSliceActions.setLoadingState());
    const data = { ...res.data.labourCost[0] };

    const factory = factoryList.find((item) => {
      return item.value === data.factory_id;
    });
    data.role = {
      value: `${data.role}`,
      label: data.role === "super_admin" ? "Super Admin" : "Factory Admin",
      type: "role",
    };
    data.status = {
      value: `${data.status}`,
      label: data.status === "active" ? "Active" : "Deactive",
      type: "status",
    };

    data.factory = {
      value: factory.value,
      label: factory.label,
      type: factory.type,
    };
    dispatch(labourCostSliceAction.getLabourCostDataEdit(data));
  };
};

export const updateLabourCostItem = (data) => {
  const { form } = getOnlyValueFromSelectObject(data);

  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const resData = await getApi(
      "post",
      `${configdata.SERVER_URL}/api/labour-costs/update/${data.id}`,
      form
    );
    if (resData?.error) {
      if (resData?.errorType === "single") {
        dispatch(
          appLevelSliceActions.setError({ msg: resData.message, isError: true })
        );
      } else {
        dispatch(
          labourCostSliceAction.setErrorData({
            message: resData.message,
            isError: true,
          })
        );
      }

      dispatch(appLevelSliceActions.setLoadingState());
      return;
    }
    dispatch(
      labourCostSliceAction.setErrorData({
        message: {},
        isError: false,
      })
    );
    dispatch(appLevelSliceActions.setIsSuccess(true));
    dispatch(labourCostSliceAction.setInitialData());
    dispatch(appLevelSliceActions.setLoadingState());
    dispatch(getAllLabourCostItems());
  };
};

export const deleteLabourCostItem = (id) => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    await getApi(
      "get",
      `${configdata.SERVER_URL}/api/labour-costs/delete/${id}`
    );
    dispatch(appLevelSliceActions.setIsSuccess(true));
    dispatch(appLevelSliceActions.setLoadingState());
  };
};
